import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Textarea } from "@/components/ui/textarea";

// Safe renderer: react-markdown does NOT render raw HTML by default (no XSS surface).
export const Markdown = ({ children, className = "" }) => (
  <div className={`md-content ${className}`}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || ""}</ReactMarkdown>
  </div>
);

export default function MarkdownInput({ value, onChange, testId }) {
  const [preview, setPreview] = useState(false);
  const tab = (active) =>
    `text-xs px-2 py-0.5 rounded transition-colors ${
      active ? "font-semibold bg-background text-foreground" : "text-muted-foreground hover:text-foreground"
    }`;
  return (
    <div className="mt-1 border border-input rounded-md overflow-hidden">
      <div className="flex items-center justify-between px-2 py-1 border-b border-input bg-secondary/40">
        <span className="text-[11px] text-muted-foreground truncate">
          Markdown — **bold**, _italic_, # heading, - list, [link](url), [^1] footnote
        </span>
        <div className="flex gap-1 shrink-0">
          <button type="button" onClick={() => setPreview(false)} className={tab(!preview)} data-testid={testId ? `${testId}-write-btn` : undefined}>Write</button>
          <button type="button" onClick={() => setPreview(true)} className={tab(preview)} data-testid={testId ? `${testId}-preview-btn` : undefined}>Preview</button>
        </div>
      </div>
      {preview ? (
        <div className="p-3 min-h-[120px] text-sm" data-testid={testId ? `${testId}-preview` : undefined}>
          {value ? <Markdown>{value}</Markdown> : <span className="text-muted-foreground italic">Nothing to preview</span>}
        </div>
      ) : (
        <Textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="border-0 rounded-none min-h-[120px] focus-visible:ring-0 focus-visible:ring-offset-0"
          data-testid={testId}
        />
      )}
    </div>
  );
}
